import { configureStore } from "@reduxjs/toolkit"
import { setAutoFreeze } from 'immer'
import logger from "redux-logger"
import dictsReducer from "./dicts"
import employeeGroupSubjectsReducer from "./employeeGroupSubjectsSlice"
import filesReducer from "./filesSlice"
import lessonMaterialReducer from "./lessonMaterialSlice"
import lessonsReducer from "./lessonsSlice"
import logBookItemsReducer from "./logBookItemsSlice"
import logBookReduder from "./logBookSlice"
import studentLogBookReducer from "./studentLogBookSlice"
import taskReducer from "./taskSlice"
import uiReducer from "./uiSlice"
import userReducer from "./userSlice"
import siteReducers from "./site"
import finalMarkLogBookReducer from "./finalMarkLogBookSlice"
import timetableReducer from "./timetableSlice"
import plansSlice from "./plansSlice"

const preloadedState = {}
// Богомерзкий костыль, но тут не мы такие, а жизнь такая. 
// https://stackoverflow.com/questions/59648434/material-table-typeerror-cannot-add-property-tabledata-object-is-not-extensibl
setAutoFreeze(false)

const store = configureStore({
    middleware: getDefaultMiddleware => process.env.NODE_ENV === "development" ? (
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }).concat(logger)
    ) : (
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        })
    ),
    reducer: {
        user: userReducer,
        ui: uiReducer,
        lessons: lessonsReducer,
        logBookItems: logBookItemsReducer,
        logBook: logBookReduder,
        employeeGroupSubjects: employeeGroupSubjectsReducer,
        studentLogBook: studentLogBookReducer,
        tasks: taskReducer,
        files: filesReducer,
        lessonMaterial: lessonMaterialReducer,
        dicts: dictsReducer,
        site: siteReducers,
        finalMarkLogBook: finalMarkLogBookReducer,
        timetable: timetableReducer,
        plans: plansSlice,
    },
    devTools: process.env.NODE_ENV !== "production",
    preloadedState,
})

export default store